// import anime from 'animejs';

// const $slideWrap = $('.carousel-news-events > .slide-wrap');
// const container = '.carousel-news-events';
// const $initSlides = $slideWrap.html();
// const slidesA = document.querySelectorAll('.carousel-news-events > .slide-wrap > .slide');

// // intit carousel
// const carousel = (container, slides) => {
//   let sliderWidth = 0;
//   let animationWidth = 0;

//   const $firstSlide = $('.carousel-news-events > .slide-wrap > .slide:first-child');
//   const $allSlides = $('.carousel-news-events > .slide-wrap > .slide');

// 	$allSlides.each(function(){
// 		animationWidth += $(this).outerWidth(false);
// 	});

// 	// detect number of visible slides
// 	let slidesVisible = $(container).width() / $firstSlide.outerWidth(false);
// 	slidesVisible = Math.ceil(slidesVisible);

//   // append the tail
//   $allSlides.slice(0).clone().appendTo($slideWrap);

// 	// Detect the slider width with appended tail
//   $allSlides.each(function(){
// 		sliderWidth += $(this).outerWidth(false);
//   });

//   // count slides to determine animation speed
// 	const slidesNumber = $('.carousel-news-events > .slide-wrap > .slide').length;
// 	var speed = slidesNumber*2000;

// 	// set slider dimensions
// 	$slideWrap.css('width', sliderWidth);

//   // Animation
//   const slideScroll = anime({
//     targets: slides[0],
//     marginLeft: -animationWidth,
//     duration: speed,
//     autoplay: false,
//     easing: 'linear',
//     loop: true,
//   });

//   $allSlides.removeAttr('style');
//   slideScroll.play();

//   $(container).on('mouseenter', '.card', slideScroll.pause );
//   $(container).on('mouseleave', '.card', slideScroll.play );
// }

// carousel(container, slidesA);


// // handle window resize + orientation change
// export const handleCarousel = () => {
//   $slideWrap.removeAttr('style').empty().html($initSlides);
//   const slidesB = document.querySelectorAll('.carousel-news-events > .slide-wrap > .slide');
//   carousel(container, slidesB);
// }
